import { api } from "~/utils/api"

export function useAllocationWarehouseMap() {
  return api.allocation.getAllocationWarehouseMap.useQuery()
}
